import React, { Component } from "react";

import Schedule from "@/components/Schedule/Schedule";
import AlternateSchedule from "@/components/Schedule/AlternateSchedule";
import { Button } from "antd";
require("@/styles/schedule.less");

class ScheduleSelector extends Component {
    state = {
        main_selected: "subschedule",
        compact_selected: "subschedule subschedule-hidden",
        next_main_selected: "subschedule subschedule-hidden",
        next_compact_selected: "subschedule subschedule-hidden",
        selected_type: 0,
        selected_week: 0,
        main_selected_button: "scheduleButton selectedButton",
        compact_selected_button: "scheduleButton",
        thisweek_selected_button: "scheduleButton selectedButton",
        nextweek_selected_button: "scheduleButton",
    }
    updateType = (option = 0) => {
        switch(option){
            case 1:
                this.setState({
                    selected_type: option,
                    main_selected_button: "scheduleButton",
                    compact_selected_button: "scheduleButton selectedButton"
                }, this.selectSchedule);
                break;
            default:
                this.setState({
                    selected_type: option,
                    main_selected_button: "scheduleButton selectedButton",
                    compact_selected_button: "scheduleButton"
                }, this.selectSchedule);
                break;
        }
    }
    updateWeek = (option = 0) => {
        switch(option){
            case 1:
                this.setState({
                    selected_week: option,
                    thisweek_selected_button: "scheduleButton",
                    nextweek_selected_button: "scheduleButton selectedButton"
                }, this.selectSchedule);
                break;
            default:
                this.setState({
                    selected_week: option,
                    thisweek_selected_button: "scheduleButton selectedButton",
                    nextweek_selected_button: "scheduleButton"
                }, this.selectSchedule);
                break;
        }
    }
    selectSchedule = () => {
        switch(this.state.selected_type){
            case 1: 
                switch(this.state.selected_week){
                    case 1: 
                        this.setState({
                            main_selected: "subschedule subschedule-hidden",
                            compact_selected: "subschedule subschedule-hidden",
                            next_main_selected: "subschedule subschedule-hidden",
                            next_compact_selected: "subschedule",
                        })
                        break;
                    default:
                        this.setState({
                            main_selected: "subschedule subschedule-hidden",
                            compact_selected: "subschedule",
                            next_main_selected: "subschedule subschedule-hidden",
                            next_compact_selected: "subschedule subschedule-hidden",
                        })
                        
                }
                break;
            default:
                switch(this.state.selected_week){
                    case 1: 
                        this.setState({
                            main_selected: "subschedule subschedule-hidden",
                            compact_selected: "subschedule subschedule-hidden",
                            next_main_selected: "subschedule",
                            next_compact_selected: "subschedule subschedule-hidden",
                        })
                        break;
                    default:
                        this.setState({
                            main_selected: "subschedule",
                            compact_selected: "subschedule subschedule-hidden",
                            next_main_selected: "subschedule subschedule-hidden",
                            next_compact_selected: "subschedule subschedule-hidden",
                        })
                }
                break;

        }
    }
    render() {
        return(
            <div className="schedule-container">
              <p>
                Purple Radio Live Schedule
              </p>
              <div className="buttonContainer">
                <button className={this.state.main_selected_button} onClick={e => this.updateType(0)}>Default</button>
                <button className={this.state.compact_selected_button} onClick={e => this.updateType(1)}>Compact</button>
                <button className={this.state.thisweek_selected_button} onClick={e => this.updateWeek(0)}>This Week</button>
                <button className={this.state.nextweek_selected_button} onClick={e => this.updateWeek(1)}>Next Week</button>
              </div>
              <div style={{"display": "flex"}}>
                <div className={this.state.main_selected}>
                  <Schedule/>
                </div>
                <div className={this.state.next_main_selected} style={{"marginLeft": "-100%"}}>
                  <Schedule nextweek={true}/>
                </div>
                <div className={this.state.compact_selected} style={{"marginLeft": "-100%"}}>
                  <AlternateSchedule/>
                </div>
                <div className={this.state.next_compact_selected} style={{"marginLeft": "-100%"}}>
                  <AlternateSchedule nextweek={true}/>
                </div>
              </div>
            </div>
        )
    }
}
export default ScheduleSelector;